import { Check, RefreshCw, Zap, User } from 'lucide-react';

export const VerifiedBadge = ({ label = 'Verificada' }) => (
  <span
    data-testid="verified-badge"
    className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium border"
    style={{ color: '#38BDF8', backgroundColor: 'rgba(56, 189, 248, 0.1)', borderColor: 'rgba(56, 189, 248, 0.3)' }}
  >
    <Check size={11} strokeWidth={3} />
    <span className="font-mono tracking-wide uppercase">{label}</span>
  </span>
);

export const ProfessionalPublishedBadge = ({ label }) => (
  <span
    data-testid="professional-published-badge"
    className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium border font-mono tracking-wide uppercase"
    style={{ color: '#A855F7', backgroundColor: 'rgba(168, 85, 247, 0.12)', borderColor: 'rgba(168, 85, 247, 0.3)' }}
  >
    <User size={11} />
    {label}
  </span>
);

export const SubstitutionBadge = ({ label }) => (
  <span
    data-testid="substitution-badge"
    className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium border font-mono tracking-wide uppercase"
    style={{ color: '#EC4899', backgroundColor: 'rgba(236, 72, 153, 0.13)', borderColor: 'rgba(236, 72, 153, 0.35)' }}
  >
    <RefreshCw size={11} />
    {label}
  </span>
);

export const UrgentBadge = ({ label }) => (
  <span
    data-testid="urgent-badge"
    className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-[11px] font-semibold border font-mono tracking-wide uppercase"
    style={{ color: '#FCA5A5', backgroundColor: 'rgba(239, 68, 68, 0.18)', borderColor: 'rgba(239, 68, 68, 0.55)' }}
  >
    <span className="sc-urgent-dot w-1.5 h-1.5 rounded-full bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.9)]" />
    <Zap size={11} />
    {label}
  </span>
);

export const CategoryTag = ({ name, accent = '#94A3B8' }) => (
  <span
    className="inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-mono tracking-wide uppercase border"
    style={{ color: accent, backgroundColor: `${accent}14`, borderColor: `${accent}33` }}
  >
    {name}
  </span>
);

export const DemoBadge = () => (
  <span
    data-testid="demo-badge"
    className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-mono font-medium tracking-[0.15em] border"
    style={{ color: '#F59E0B', backgroundColor: 'rgba(245, 158, 11, 0.08)', borderColor: 'rgba(245, 158, 11, 0.3)' }}
  >
    DEMO
  </span>
);

export const StatusBadge = ({ status, label }) => {
  const styles = {
    available: { color: '#10B981', bg: 'rgba(16,185,129,0.12)', border: 'rgba(16,185,129,0.3)' },
    onTour: { color: '#F59E0B', bg: 'rgba(245,158,11,0.12)', border: 'rgba(245,158,11,0.3)' },
  }[status] || { color: '#94A3B8', bg: 'rgba(148,163,184,0.1)', border: 'rgba(148,163,184,0.3)' };
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-mono tracking-wide uppercase border"
      style={{ color: styles.color, backgroundColor: styles.bg, borderColor: styles.border }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: styles.color }} />
      {label}
    </span>
  );
};
